import type { TCorretagem, TParticipacao, TPropostaSchemaInput } from '@/features/proposta/schemas'
import { formatToBRL } from '@/utils/currency.utils'

export type TPagaPor = 'Grupo Plaenge' | 'Cliente'

export interface ParticipacaoResumo {
  id: string
  nome: string
  pagaPor: TPagaPor
  participacao: string
  tipo: 'CPF' | 'CNPJ'
  documento: string
}

export class ResumoParticipacoesImobiliarias {
  static from(
    detalhes: TPropostaSchemaInput['detalhesDaProposta']['imobiliariasCorretores'],
  ): readonly ParticipacaoResumo[] {
    if (detalhes.incluirParticipacoes !== 'Sim') return []
    const pagaPor: TPagaPor = detalhes.formaPagamentoComissao === 'PagaPeloCliente' ? 'Cliente' : 'Grupo Plaenge'
    return detalhes.participacoes.map((p) => ResumoParticipacoesImobiliarias.mapParticipacaoResumo(p, pagaPor))
  }

  private static formatCorretagem(corretagem: TCorretagem): string {
    return corretagem.tipo === 'valor'
      ? formatToBRL(corretagem.valorCorretagemImobiliaria ?? 0)
      : `${corretagem.percentualCorretagemImobiliaria}%`
  }

  private static mapParticipacaoResumo(participacao: TParticipacao, pagaPor: TPagaPor): ParticipacaoResumo {
    return {
      id: participacao.imobiliariaCorretor.idExterno,
      nome: participacao.imobiliariaCorretor.nome,
      pagaPor,
      participacao: this.formatCorretagem(participacao.corretagem),
      tipo: participacao.imobiliariaCorretor.tipoImobiliariaCorretor === 'CorretorAutonomo' ? 'CPF' : 'CNPJ',
      documento: participacao.imobiliariaCorretor.documento,
    }
  }
}
